import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../Shared/ErrorPopUp'
import { AsyncWarehouseSelect } from '../Shared/AsyncWarehouseSelect'
import { AsyncCategorySelect } from '../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../Shared/AsyncBrandSelect'
import AsyncProductsMultiSelect from '../Shared/AsyncProductsMultiSelect'
import unitTypes from '../../_constants/unitTypes'


export default ({ touched, errors, setFieldValue, values, handleBlur, categoryType }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <div className="row">
        <div className="form-inline">

          <div className="col-md-4">
            <label>نام انبار</label>
            <AsyncWarehouseSelect
              // categoryType={categoryType}
              defaultValue={values.unitId}
              onChange={(val, unitType_) => {

                if (unitType_ !== undefined) {

                  var unitType = (unitTypes.filter(el => el.value === unitType_)[0]);

                  if (unitType !== undefined) {

                    categoryType = unitType.categoryType;

                    setFieldValue('categoryType', categoryType)

                  }

                }

                setFieldValue('unitId', val)
              }}

              className={getIn(touched, "unitId") ? getIn(errors, "unitId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="unitId" />
          </div>

          <div className="col-md-4">
            <label>دسته بندی</label>
            <AsyncCategorySelect
              categoryType={values.categoryType}
              defaultValue={values.categoryId}
              onChange={(val) => {
                // console.log(val);

                setFieldValue('categoryId', val)
              }}

              className={getIn(touched, "categoryId") ? getIn(errors, "categoryId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="categoryId" />
          </div>

          <div className="col-md-4">
            <label>برند</label>
            <AsyncBrandSelect
              brandType={values.categoryType === -1 ? -1 : values.categoryType === 0 ? 0 : 1}
              defaultValue={values.brandId}
              onChange={(val) => {
                // console.log(val);

                setFieldValue('brandId', val)
              }}

              className={getIn(touched, "brandId") ? getIn(errors, "brandId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="brandId" />
          </div>


          <div className="col-md-12 col-sm-12">
            <label>انتخاب کالاها</label>
            <AsyncProductsMultiSelect
              brandId={values.brandId}
              categoryId={values.categoryId}
              // defaultValue={values.productId}
              name="productId"
              onChange={(val, measurementType) => {
                // console.log(val);

                setFieldValue('ids', val)
              }}

              className={getIn(touched, "ids") ? getIn(errors, "ids") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="ids" />
          </div>


        </div>
      </div>

    </div>

  </div>
);